import { styled } from '../../styled';
export var TableEmptyState = styled('div', { name: 'TableEmptyState', slot: 'root' })(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(2),
        backgroundColor: theme.tokens.color_bg_layer_alternate,
        borderRadius: 3,
        textAlign: 'center',
        marginTop: theme.spacing(2),
        color: theme.tokens.color_fg_bold,
    });
});
